import React, { Component } from 'react';
import './css/Actividad.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome' 
import BootstrapTable from 'react-bootstrap-table-next';
import { Modal, Col, Row, Container } from 'react-bootstrap';
import { Solicitud_actividad } from './expand/Solicitud_actividad';
import { faSync, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";

const API_URL = process.env.REACT_APP_API_URL;

function color_head() {
    return {
        backgroundColor: '#25223f',
        color: 'white',
        width: '15%', fontSize: 11,
    };
}
function color_head_desc(tipo) {
    if (tipo == 'a') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '50%'
        };
    } else if (tipo == 'd') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        }
    } else if (tipo == 'id') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '10%'
        };
    } else {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        };
    }
}
function color_head_desc_gen(tipo) {
    if (tipo == 'ob') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '25%'
        };
    } else if (tipo == 'd') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '18%'
        }
    } else if (tipo == 'idn') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '5%'
        };
    } else if (tipo == 'estado') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '8%'
        };
    } else if (tipo == 'mensaje') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '16%'
        };
    } else if (tipo == 'accion') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '8%'
        };
    } else if (tipo == 'periodo') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '8%'
        };
    } else {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '12%'
        };
    }
}
//Funcion para colocar color a las celdasde la tabla
function color(rowIndex) {
    if (rowIndex % 2 === 0) {
        return {
            backgroundColor: 'white'
        };
    }
    return {
        backgroundColor: '#E7E7E7'
    };
}
 

export class Resumen_final extends Component {
    static displayName = Resumen_final.name;

    constructor(props) {
        super(props);
        this.state = {
            actividades: [], loading: false, loading2: false, accion: "", rechazos: this.props.rechazos
        };
          
    
    }

     
    componentDidMount() {
        this.populateActividadesData();

        //console.log('didmount del solicitud general ')

        let btnfin = document.getElementsByClassName('btn-finish');
        //console.log(btnfin)
        if (btnfin[0] != undefined) {
            //console.log('dentro del no UNDEFINED finis RENDER button')
            //btnfin[0].style.display = "none";

            //btnfin.hidden = true;
        }


    }
     
    formatter = (valor) => {
        return new Intl.NumberFormat('en-US', { maximumFractionDigits: '2', minimumFractionDigits: '2', signDisplay: 'never' }).format(valor)
    }

    dateFormatter = (strFecha) => {
        var options = { year: 'numeric', month: '2-digit', day: 'numeric' };
        var dtFecha = new Date(strFecha);
        return dtFecha.toLocaleDateString("es-EC", options);
    }

    render() {
        // tabla resumen
        const columns_acti = [
            {
                dataField: 'id',
                text: '#',

                footer: '',
                headerStyle: color_head_desc_gen('idn'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                formatter: (cellContent, row, rowIndex) => {
                    return (
                        <div>
                            {rowIndex + 1}
                        </div>
                    )
                }
            },
            {
                dataField: 'tipo',
                text: 'Ámbito',
                headerStyle: color_head_desc_gen('amb'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: '',
                formatter: (cellContent, row, rowIndex) => {
                    var ambito = row.tipo.split('|')[1]
                    if (ambito === "R") {
                        return (<div>Docencia Grado</div>)
                    } else if (ambito === "P") {
                        return (<div>Docencia PostGrado</div>)
                    } else if (ambito === "V") {
                        return (<div>Vinculación</div>)
                    } else if (ambito === "I") {
                        return (<div>Investigación</div>)
                    } else if (ambito === "G") {
                        return (<div>Gestion Académica</div>)
                    } else {
                        return (<div>Docencia Admisión</div>)
                    }
                    
                }
            },
            {
                dataField: 'idplnvalidaciondet',
                text: '#',
                hidden: true,
                headerStyle: color_head_desc('id'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: ''
            }, {
                dataField: 'descripcion',
                text: 'Descripción',
                headerStyle: color_head_desc_gen('d'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: ''
            }, {
                dataField: 'observacion',
                text: 'Observación',
                headerStyle: color_head_desc_gen('ob'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: ''
            }, {
                dataField: 'accion',
                text: 'Acción',
                headerStyle: color_head_desc_gen('accion'),
                formatter: (cellContent, row) => {
                    var accion = row.accion
                    if (row.accion == 'M') {
                        return (<><span className="badge badge-pill badge-warning">Modificar carga</span></>);
                    } else if (row.accion == 'C') {
                        return (<><span className="badge badge-pill badge-success">Nueva carga</span></>);
                    } else {
                        return (<><span className="badge badge-pill badge-danger">Eliminar carga</span></>);
                    }

                },
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: ''
            },
            {
                dataField: 'periodo',
                text: 'Periodo',
                headerStyle: color_head_desc_gen('periodo'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                formatter: (cellContent, row) => {
                    return (<>{row.periodo}</>);
                },
                footer: ''
            }, 
             {
                text: 'Estado',
                isDummyField: true,
                headerStyle: color_head_desc_gen('estado'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                 formatter: (cellContent, row, rowIndex) => {
                     var elementoSC = this.state.rechazos ? this.state.rechazos.find(x => x.idVal === row['idplnvalidaciondet']) : null;
                     //console.log("elementoSC: ", elementoSC);

                    return (
                        <>
                            {/*{this.state.rechazos && this.state.rechazos.some(x => x.idVal === row['idplnvalidaciondet'])*/}
                            {/*    ? <div>*/}
                            {/*     {this.state.rechazos.some(x => x.idVal === row['idplnvalidaciondet']) ? (<><span className="badge badge-pill badge-danger">RECHAZADO</span></>) :*/}
                            {/*            (<><span className="badge badge-pill badge-warning">PENDIENTE</span></>) }*/}
                            {/*</div>*/}
                            {/*: <div><><span className="badge badge-pill badge-warning">PENDIENTE</span></></div>}*/}
                            
                                {this.state.rechazos && this.state.rechazos.some(x => x.idVal === row['idplnvalidaciondet'])
                                ? <div>
                                    {elementoSC["estado"] === "A" && <><span className="badge badge-pill badge-success">APROBADO</span></>}
                                    {(elementoSC["estado"] === "R" || elementoSC["estado"] === "RA") && <><span className="badge badge-pill badge-danger">RECHAZADO</span></>}
                                    {elementoSC["estado"] === "P" && <><span className="badge badge-pill badge-warning">PENDIENTE</span></>}
                                  </div>
                                : <div><><span className="badge badge-pill badge-warning">PENDIENTE</span></></div>}
                        </>
                    )
                },
                footer: ''
            },
            {
                text: 'Mensaje',
                isDummyField: true,
                headerStyle: color_head_desc_gen('mensaje'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                formatter: (cellContent, row, rowIndex) => {
                    return (
                        <>
                            {this.state.rechazos ? this.state.rechazos.some(x => x.idVal === row['idplnvalidaciondet'])
                                ? <div>
                                    {this.state.rechazos.find(x => x.idVal === row['idplnvalidaciondet']).mensaje}
                                </div>
                                : <></> : <></>}
                        </>
                    )
                },
                footer: ''
            } ];



        return (
            <div>
                  
                       

                {this.state.actividades && this.state.actividades.length > 0 ?
                     <><Row>
                            <Col md="6">
                                <h4 className='resumen'>RESUMEN DE CARGA OBSERVADA</h4>
                            </Col>
                            <Col md="6"><hr />
                            </Col>
                        </Row>
                        <BootstrapTable
                            keyField='idplnvalidaciondet'
                            data={this.state.actividades}
                            columns={columns_acti}
                            bordered={false}  
                    /></> : null
                }
                      


            </div>
        );
    }

    async populateActividadesData() {
        //console.log("EO")
        const response = await fetch(API_URL + 'TPlnValidacionDets/' + this.props.idcargadet);
        //console.log("EO")
        const respuesta = await response.json();
        const data = respuesta;
        //console.log("DATA FINAAL", respuesta)
        this.setState({ actividades: data, loading: false });


    }
}
